import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import { Notifier } from '@softwaredev_cegeka/stix-notifier'

import Main from './routes/Main'
import withAuth from './components/auth/withAuth'
import UnauthorizedPage from './routes/UnAuthorizedPage'
import './App.scss'

function App() {
    return (
        <Notifier>
            <Router>
                <Switch>
                    <Route
                        exact
                        path={'/unauthorized'}
                        component={UnauthorizedPage}
                    />
                    <Route path="/" component={withAuth(Main)} />
                </Switch>
            </Router>
        </Notifier>
    )
}

export default App
